import { Formik } from "formik";
import React, { useContext, useState } from "react";
import { CompleteNewPasswordFormValues } from "../../app/models/signin/form-values-complete-new-password";
import { Store } from "../../app/stores/store-root";
import {useHistory} from 'react-router-dom';

export const SetNewPassword = () => {
  const store = useContext(Store);
  const { completeNewPassword } = store.Users;
  const [user, setUser] = useState(new CompleteNewPasswordFormValues());
  const history = useHistory()

  return (
    <Formik
      initialValues={user}
      enableReinitialize={true}
      onSubmit={(values) => {
        console.log(values);
       completeNewPassword(values);
      }}
    >
      {(formik: any) => (
        <form onSubmit={formik.handleSubmit}>
          <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
            <div className="mx-auto w-full max-w-sm lg:w-96">
              <div>
                <img
                  className="h-12 w-auto"
                  src="./favicon.svg"
                  alt="Workflow"
                />
                <h2 className="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
                  Reset your account password
                </h2>
              </div>
              <div className="mt-8">
                <div className="mt-6">
                  <div className="space-y-6">
                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium leading-5 text-gray-700"
                      >
                        User name
                      </label>
                      <div className="mt-1 rounded-md shadow-sm">
                        <input
                          {...formik.getFieldProps("email")}
                          name="email"

                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium leading-5 text-gray-700"
                      >
                        Current password
                      </label>
                      <div className="mt-1 rounded-md shadow-sm">
                        <input
                          {...formik.getFieldProps("currentPassword")}
                          name="currentPassword"
                          type="currentPassword"
                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="new"
                        className="block text-sm font-medium leading-5 text-gray-700"
                      >
                        New password
                      </label>
                      <div className="mt-1 rounded-md shadow-sm">
                        <input
                          {...formik.getFieldProps("new")}
                          id="new"
                          name="new"
                          type="password"
                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="password"
                        className="block text-sm font-medium leading-5 text-gray-700"
                      >
                        Confim new password
                      </label>
                      <div className="mt-1 rounded-md shadow-sm">
                        <input
                          {...formik.getFieldProps("confirm")}
                          id="confirm"
                          name="confirm"
                          type="password"
                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                    </div>
                    {/* <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <input
                          id="remember_me"
                          type="checkbox"
                          className="form-checkbox h-4 w-4 text-gray-600 transition duration-150 ease-in-out"
                        />
                        <label
                          htmlFor="remember_me"
                          className="ml-2 block text-sm leading-5 text-gray-900"
                        >
                          Remember me
                        </label>
                      </div>
                      <div className="text-sm leading-5">
                        <a
                          href="#"
                          className="font-medium text-gray-600 hover:text-gray-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                        >
                          Forgot your password?
                        </a>
                      </div>
                    </div> */}
                    <div className='pt-6'>
                      <span className="block w-full rounded-md shadow-sm">
                        <button
                          type="submit"
                          className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-600 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 transition duration-150 ease-in-out font-bold"
                        >
                          Confirm
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
